import { render, staticRenderFns } from "./CompanyListDetail.vue?vue&type=template&id=363e5edb"
import script from "./CompanyListDetail.vue?vue&type=script&lang=js"
export * from "./CompanyListDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyListDetail.vue?vue&type=style&index=0&id=363e5edb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports